import { Client } from './client';

export class Tag {
  id: string;
  name: string;
  position: number;
  client?: Client;
  clientId: string;
}
